module.exports = __webpack_public_path__ + "img/bluetooth.a21b954d.jpg";